<div class="sector-item mb-3">
    <div class="description">
        <div class="thumbnail">
            <div class="img-container">
                <div class="content">
                    <img [src]="sector?.image?.url" loading="lazy">
                </div>
            </div>
        </div>
        <div class="details">
            <h2 class="title">{{translateHelper.localize(sector?.name)}}</h2>
            <div class="text">
                <div class="tags">{{translateHelper.localize(sector?.description)}}</div>
            </div>
        </div>
    </div>
    <div class="controls">
        <a class="btn flex btn-secondary" [routerLink]="['/sector', sector?.seo?.slug, 'site', 'stores']">
            <div class="icon"><mat-icon>person</mat-icon></div>
            <div class="label">{{translateHelper.localize(sector?.secondaryButton)}}</div>
        </a>
        <a class="btn btn-primary" [routerLink]="['/sector', sector?.seo?.slug]">
            <div class="label">{{translateHelper.localize(sector?.mainButton)}}</div>
        </a>
    </div>
</div>